export const CASHIER_STEP_STATUSES = {
    COMPLETED: 'completed',
    IN_PROGRESS: 'in-progress',
    WAITING: 'waiting',
};

export const CASHIER_STEP_CONFIG = {
    [CASHIER_STEP_STATUSES.COMPLETED]: { iconName: 'IcCheckMarkCircle', iconColor: 'var(--color-green-secondary)' },
    [CASHIER_STEP_STATUSES.IN_PROGRESS]: { iconName: 'IcClock', iconColor: 'var(--color-white-60)' },
    [CASHIER_STEP_STATUSES.WAITING]: { iconName: 'IcDot', iconColor: 'var(--color-neutral-20)' },
};
